import { render, staticRenderFns } from "./UploadedFiles.vue?vue&type=template&id=3270443b&scoped=true"
import script from "./UploadedFiles.vue?vue&type=script&lang=js"
export * from "./UploadedFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3270443b",
  null
  
)

export default component.exports